define('rest/reverseGeocode',["http", "./utils", "security"],
    function (http, utils, security) {
        "use strict";

        var queryParamNames = [
            "spatialKeys", "returnSpeedLimit", "heading", "radius", "streetNumber", "returnRoadUse", "roadUse"
        ];

        return {
            reverseGeocode: function (options, callback) {
                var pathParams = {}, queryParams = {};

                // Required parameter: position
                pathParams.position = utils.required(options.position, "\"position\" parameter is required for reverseGeocode service.");

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey("services/search"));
                pathParams.type = utils.required(options.type, "Missing type definition in Search service");

                // optional parameters (spatialKeys, returnSpeedLimit, heading, radius, streetNumber, returnRoadUse,
                // roadUse) look for optional passed params and set them if they are not undefined
                utils.extractQueryParams(options, queryParams, queryParamNames);

                var baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/");
                var serviceUrl = utils.or(options.serviceUrl, "search/2/{type}/{position}.{contentType}");

                http.get({
                    url: baseUrl + serviceUrl,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: "callback",
                    fail: options.fail
                });
            }
        };
    }
);

